import { useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import React from 'react'

import { useModuleIds, useUserProjectRole } from 'portal/lib/hooks'
import { insightsLoad, insightsReload } from 'portal/store/insights/actions'
import { SmallSpinner } from 'portal/lib/primitives'

export const useReportsLoader = () => {
  const dispatch = useDispatch()
  const { accountId, projectId } = useModuleIds()

  const { isReadOnly } = useUserProjectRole(accountId, projectId)

  const reload = useCallback(() => {
    if (accountId) {
      dispatch(insightsLoad(accountId))
    }
  }, [dispatch, accountId])

  useEffect(() => {
    reload()
  }, [reload])

  const { loading, error, items, count } = useSelector((state: any) => {
    return state.insights
  })

  function showTotalRecords(): React.ReactNode {
    if (loading && items.length === 0) {
      return (
        <SmallSpinnerWrapper>
          <SmallSpinner />
        </SmallSpinnerWrapper>
      )
    }
    if (error !== null) {
      return 'Error fetching total reports'
    }
    return (
      <ShowingRecordsText data-testid="totalInPage">
        Showing {items.length} report
        {items.length === 1 ? '' : 's'}
      </ShowingRecordsText>
    )
  }

  const silent_reload = useCallback(() => {
    if (accountId) {
      dispatch(insightsReload(accountId))
    }
  }, [dispatch, accountId])

  useEffect(() => {
    const id = setInterval(() => {
      silent_reload()
    }, 900000) // 15 minutes
    return () => clearInterval(id)
  }, [silent_reload])

  return {
    loading,
    error,
    items,
    count,
    reload,
    showTotalRecords,
    readOnly: isReadOnly
  }
}

const ShowingRecordsText = styled.div`
  margin: 1rem 0.5rem 0;
  text-align: center;
`
const SmallSpinnerWrapper = styled.div`
  position: relative;
  margin-top: 0.5rem;
`
